<div class="modal fade show d-block shadow-lg" tabindex="-1">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content border-0 rounded-lg shadow-xl overflow-hidden bg-white">
      <!-- Header -->
      <div class="modal-header bg-dark text-white p-3 px-4 cute-header">
        <div class="d-flex align-items-center gap-3">
          <div class="icon-circle bg-white shadow-sm text-dark d-flex align-items-center justify-content-center" style="width: 32px; height: 32px; border-radius: 8px;">
            <i class="bi bi-clock-history"></i>
          </div>
          <div>
            <h6 class="modal-title text-sm fw-bold mb-0 tracking-wider">COMPLIANCE ANSWER HISTORY</h6>
            <p v-if="question" class="text-xxs text-white-50 mb-0 opacity-75">
              Ref: {{ question.id || question.compliance_field_id }} | {{ question.question_text }}
            </p>
          </div>
        </div>
        <button type="button" class="btn-close btn-close-white" @click="$emit('close')"></button>
      </div>

      <!-- Body -->
      <div class="modal-body p-0" style="max-height: 70vh; overflow-y: auto;">
        <!-- Loading -->
        <div v-if="history_loading" class="text-center py-5">
          <div class="spinner-border text-primary-dark spinner-border-sm" role="status"></div>
          <p class="text-xxs mt-2 text-muted">Fetching historical records...</p>
        </div>

        <!-- Empty -->
        <div v-else-if="!history_data.length" class="text-center py-5">
          <div class="mb-3 opacity-25">
            <i class="bi bi-folder-x fs-1"></i>
          </div>
          <p class="text-xs text-muted fw-bold">No historical submissions found</p>
        </div>

        <!-- List -->
        <div v-else class="history-table-container">
          <div class="table-responsive">
            <table class="table table-hover align-middle mb-0">
              <thead class="bg-light">
                <tr>
                  <th class="ps-4 text-xxs text-muted text-uppercase fw-bold py-3">Version</th>
                  <th class="text-xxs text-muted text-uppercase fw-bold py-3">Submitted Answer</th>
                  <th class="text-xxs text-muted text-uppercase fw-bold py-3">Submitted By</th>
                  <th class="text-xxs text-muted text-uppercase fw-bold py-3">Answered Date</th>
                  <th class="text-xxs text-muted text-uppercase fw-bold py-3 text-primary">Due Date</th>
                  <th class="pe-4 text-xxs text-muted text-uppercase fw-bold py-3 text-end">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in history_data" :key="item.id" class="border-bottom">
                  <td class="ps-4 py-3">
                    <span class="badge bg-dark-transparent text-dark text-xxs rounded-pill px-2">v{{ item.version }}</span>
                  </td>
                  <td class="py-3">
                    <!-- File Preview -->
                    <div v-if="item.question_type_raw && ['file','facial_verification'].includes(item.question_type_raw)" class="d-flex align-items-center gap-2">
                       <i class="bi bi-file-earmark-text text-primary fs-6"></i>
                       <span class="text-xxs text-dark text-truncate d-inline-block" style="max-width: 180px;" :title="get_file_name_from_url(item.answer)">
                         {{ get_file_name_from_url(item.answer) }}
                       </span>
                       <button class="btn btn-primary-dark btn-xs p-1 px-2 rounded-small text-xxs" @click="open_file_preview(item.answer, get_file_name_from_url(item.answer))">
                         View
                       </button>
                    </div>
                    <!-- Text Answer -->
                    <div v-else class="text-xxs text-dark fw-bold">
                      "{{ item.answer }}"
                    </div>
                  </td>
                  <td class="py-3">
                    <div class="d-flex align-items-center gap-2">
                      <div class="avatar-xxs rounded-circle bg-light d-flex align-items-center justify-content-center text-xxs fw-bold text-primary" style="width: 24px; height: 24px;">
                        {{ (item.user_first_name || 'S')[0] }}
                      </div>
                      <span class="text-xxs text-dark">{{ item.user_first_name }} {{ item.user_last_name }}</span>
                    </div>
                  </td>
                  <td class="py-3 text-xxs text-muted tabular-nums">
                    {{ format_datetime(item.date_answered) }}
                  </td>
                  <td class="py-3 text-xxs fw-bold text-primary tabular-nums">
                    {{ format_date(item.due_date) }}
                  </td>
                  <td class="pe-4 py-3 text-end">
                    <span class="status-pill text-xxs px-2" :class="get_badge_class(item.status)">
                       {{ get_label(item.status) }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Footer/Pagination -->
      <div class="modal-footer bg-light p-2 px-4 d-flex justify-content-between align-items-center border-0">
        <div class="text-xxs text-muted fw-bold">
           Showing Page {{ history_page }} of {{ history_total_pages }}
        </div>
        <nav v-if="history_total_pages > 1">
          <ul class="pagination pagination-sm m-0 gap-1 border-0">
            <li class="page-item" :class="{ disabled: history_page === 1 }">
              <button class="page-link shadow-none rounded-small text-xxs border-0" @click="change_page(history_page - 1)">Previous</button>
            </li>
            <li v-for="p in history_total_pages" :key="p" class="page-item" :class="{ active: history_page === p }">
              <button class="page-link shadow-none rounded-small text-xxs border-0" :style="history_page === p ? 'background: var(--primary-dark); color: white;' : ''" @click="change_page(p)">{{ p }}</button>
            </li>
            <li class="page-item" :class="{ disabled: history_page === history_total_pages }">
              <button class="page-link shadow-none rounded-small text-xxs border-0" @click="change_page(history_page + 1)">Next</button>
            </li>
          </ul>
        </nav>
        <button class="btn btn-outline-dark btn-sm rounded-small text-xxs px-4 shadow-sm" @click="$emit('close')">Close</button>
      </div>
    </div>

    <!-- Nested File Preview -->
    <teleport to="body">
      <FilePreviewComponent
        v-if="show_file_preview"
        :presigned_url="preview_file_url"
        :file_name="preview_file_name"
        @close="close_file_preview"
        :key="preview_file_url"
      />
    </teleport>
  </div>
  <div class="modal-backdrop fade show"></div>
</div>
